import React, { useEffect, useState } from "react";

// Trailing non-breaking space: the flex container strips a normal trailing space.
const HOST_PREFIX = "Host a\u00A0";
const HOST_WORDS = ["party", "workshop", "class", "social", "night"];
const LONGEST_WORD_CH = Math.max(...HOST_WORDS.map((w) => w.length));
const TYPE_MS = 85;
const DELETE_MS = 55;
const PAUSE_TYPED_MS = 2200;
const PAUSE_DELETED_MS = 400;

export const HOST_TYPEWRITER_ARIA_LABEL = "Host something fun, workshop, class, social, or night";

function prefersReducedMotion() {
  return typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default function HostTypewriterLabel({ className = "" }) {
  const [reducedMotion] = useState(prefersReducedMotion);
  const [wordIndex, setWordIndex] = useState(0);
  const [text, setText] = useState(reducedMotion ? HOST_WORDS[0] : HOST_WORDS[0]);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (reducedMotion) return undefined;

    const word = HOST_WORDS[wordIndex];
    let timeout;

    if (!deleting && text === word) {
      timeout = setTimeout(() => setDeleting(true), PAUSE_TYPED_MS);
    } else if (deleting && text === "") {
      timeout = setTimeout(() => {
        setDeleting(false);
        setWordIndex((i) => (i + 1) % HOST_WORDS.length);
      }, PAUSE_DELETED_MS);
    } else {
      const delay = deleting ? DELETE_MS : TYPE_MS;
      timeout = setTimeout(() => {
        setText(deleting ? word.slice(0, text.length - 1) : word.slice(0, text.length + 1));
      }, delay);
    }

    return () => clearTimeout(timeout);
  }, [text, deleting, wordIndex, reducedMotion]);

  return (
    <span className={`inline-flex items-baseline whitespace-nowrap ${className}`}>
      {HOST_PREFIX}
      <span
        className="inline-block text-left tabular-nums"
        style={{ minWidth: `calc(${LONGEST_WORD_CH}ch + 0.6ch)` }}
      >
        {text}
        {!reducedMotion && (
          <span className="typewriter-cursor" aria-hidden="true">
            |
          </span>
        )}
      </span>
    </span>
  );
}
